import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  CLEAR_BUS_BODY_WORK,
  CLEAR_BUSES_BODY_WORKS,
  FLAG_BUSES_BODY_WORKS_ACTIVITY,
  FLAG_GETTING_BUSES_BODY_WORKS,
  GET_BUS_BODY_WORK,
  GET_BUSES_BODY_WORKS,
} from '../types';
import { BUS_BODYWORK_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_DELETE_CONFIG, DEFAULT_GET_CONFIG, DEFAULT_POST_CONFIG, DEFAULT_PUT_CONFIG } from '../../config/rest';
import { push } from 'react-router-redux';
import { BUS_BODY_WORK_PATH } from '../../config/paths';

const flagGettingBusesBodyWorks = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_GETTING_BUSES_BODY_WORKS,
  });

const getBusesBodyWorks = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingBusesBodyWorks(true));
    const query = tableFilters;
    const url = `${BUS_BODYWORK_ENDPOINT}?${QueryString.stringify(query)}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise);
    const response = await promise.json();
    dispatch({
      type: GET_BUSES_BODY_WORKS,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingBusesBodyWorks(false));
  }
};

const clearBusBodyWorks = () => (dispatch) =>
  dispatch({ type: CLEAR_BUSES_BODY_WORKS });

const flagGettingBusBodyWork = (flag) => (dispatch) =>
  dispatch({
    payload: flag,
    type: FLAG_BUSES_BODY_WORKS_ACTIVITY,
  });

const getBusBodyWork = async ({ busBodyWorkId }) => async (dispatch) => {
  try {
    dispatch(flagGettingBusBodyWork(true));
    const url = `${BUS_BODYWORK_ENDPOINT}/${busBodyWorkId}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise);
    const response = await promise.json();
    dispatch({
      type: GET_BUS_BODY_WORK,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingBusBodyWork(false));
  }
};

const createNewBusBodyWork = async ({
  name,
  make,
  model,
  year,
  fuelCapacity
}) => {
  const payload = {
    make,
    model,
    year,
    fuelCapacity
  };
  const url = BUS_BODYWORK_ENDPOINT;
  const promise = await fetch(url, {
    ...DEFAULT_POST_CONFIG,
    body: JSON.stringify(payload),
  });
  await isErrorResponse(promise);
  const busBodyWork = await promise.json();
  return busBodyWork;
};

const postBusBodyWork =
  async ({
    make,
    model,
    year,
    fuelCapacity
  }) =>
    async (dispatch) => {
      try {
        dispatch(flagGettingBusBodyWork(true));
        const response = await createNewBusBodyWork({
          make,
          model,
          year,
          fuelCapacity
        });
        if (response) {
          dispatch(push(`${BUS_BODY_WORK_PATH}/${response.id}`));
        }
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagGettingBusBodyWork(false));
      }
    };

const putBusBodyWork =
  async (
    busBodyWorkId,
    {
      make,
      model,
      year,
      fuelCapacity
    },
  ) =>
    async (dispatch) => {
      try {
        dispatch(flagGettingBusBodyWork(true));
        const payload = {
          id: busBodyWorkId,
          make,
          model,
          year,
          fuelCapacity
        };
        const url = `${BUS_BODYWORK_ENDPOINT}/${busBodyWorkId}`;
        const promise = await fetch(url, {
          ...DEFAULT_PUT_CONFIG,
          body: JSON.stringify(payload),
        });
        await isErrorResponse(promise, null, dispatch);
        await promise.json();
        dispatch(push(`${BUS_BODY_WORK_PATH}/${busBodyWorkId}`));
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagGettingBusBodyWork(false));
      }
    };

const deleteBusBodyWork =
  async ({ busBodyWorkId }) =>
    async (dispatch) => {
      try {
        dispatch(flagGettingBusBodyWork(true));
        const url = `${BUS_BODYWORK_ENDPOINT}/${busBodyWorkId}`;
        const promise = await fetch(url, {
          ...DEFAULT_DELETE_CONFIG,
        });
        await isErrorResponse(promise, null, dispatch);
        await promise.json();
        dispatch(push(BUS_BODY_WORK_PATH));
      } catch ({ message }) {
        toastr.error('Error', message);
      } finally {
        dispatch(flagGettingBusBodyWork(false));
      }
    };

const clearBusBodyWork = () => (dispatch) =>
  dispatch({ type: CLEAR_BUS_BODY_WORK });

export { clearBusBodyWorks, getBusesBodyWorks, postBusBodyWork, putBusBodyWork, deleteBusBodyWork, getBusBodyWork, clearBusBodyWork };
